// 各类报表
export default [
  {
    path: '/revenueReport',
    name: 'revenueReport',
    component: () => import ('@/components/page/report/revenueReport')
  },{
    path: '/revenueReportChart',
    name: 'revenueReportChart',
    component: () => import ('@/components/page/report/revenueReportChart')
  },
  {
    path: '/revenueReportMulti',
    name: 'revenueReportMulti',
    component: () => import ('@/components/page/report/revenueReportMulti')
  },
  {
    path: '/revenueReportRongtongArmy',
    name: 'revenueReportRongtongArmy',
    component: () => import ('@/components/page/report/revenueReportRongtongArmy')
  },
  {
    path: '/revenueCompare',
    name: 'revenueCompare',
    component: () => import ('@/components/page/report/revenueCompare')
  },
  {
    path: '/cashierReport',
    name: 'cashierReport',
    component: () => import ('@/components/page/report/cashierReport')
  },
  {
    path: '/payReport',
    name: 'payReport',
    component: () => import ('@/components/page/report/payReport')
  },
  {
    path: '/roomPrediectionReport',
    name: 'roomPrediectionReport',
    component: () => import ('@/components/page/report/roomPrediectionReport')
  },
  {
    path: '/orderFromReport',
    name: 'orderFromReport',
    component: () => import ('@/components/page/report/orderFromReport')
  },
  {
    path: '/shirtReport',
    name: 'shirtReport',
    component: () => import ('@/components/page/report/shirtReport')
  },
  // 会员同比表现，按酒店区分
  {
    path: '/memberContrast',
    name: 'memberContrast',
    component: () => import ('@/components/page/report/memberContrast')
  },
  // 会员同比表现,按项目区分
  {
    path: '/memberSingleContrast',
    name: 'memberSingleContrast',
    component: () => import ('@/components/page/report/memberSingleContrast')
  },
  // 会员同比表现,按项目区分
  {
    path: '/memberMoreHotelContrast',
    name: 'memberMoreHotelContrast',
    component: () => import ('@/components/page/report/memberMoreHotelContrast')
  },
  // 会员表现,按酒店区分
  {
    path: '/memberPerformance',
    name: 'memberPerformance',
    component: () => import ('@/components/page/report/memberPerformance')
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/report.js